<template>
	<div>
		<div v-loading="loading" class="hotspot-panel" element-loading-background="rgba(0, 0, 0, 0.8)">
			<div class="hotspot-panel-title">任务列表</div>
			<div v-if="lists.length == 0" class="hotspot-placeholder">暂无折线</div>
			<div v-else class="hotspot-list">
				<div class="item" v-for="item in lists" :key="item.id">
					<div class="title">{{ item.title }}-{{ item.id }}</div>
					<div class="operate v-row">
						<div class="btn">{{ polylineInfo[item.status].text }}</div>
						<div class="line">|</div>
						<div class="btn" @click="positionHotspot(item)">定位</div>
						<div v-if="item.is_own == 1" class="line">|</div>
						<el-popconfirm v-if="item.is_own == 1" title="确认删除?" @onConfirm="deleteHotSpot(item)">
							<div slot="reference" class="btn" v-loading="item.deleteLoading">删除</div>
						</el-popconfirm>
					</div>
				</div>
			</div>
			<div class="panel-footer">
				<div class="btn v-bg-yellow" @click="startDrawing($event, 1)">
					<i class="iconfont icon-draw-rect"></i>
					<div class="label" style="margin-left: 3px">框选问题</div>
				</div>
				<div class="btn v-bg-blue" @click="startDrawing($event, 2)">
					<i class="iconfont icon-draw-click"></i>
					<div class="label" style="margin-left: 3px">点选问题</div>
				</div>
				<div class="btn btn-cancel" @click="closeDialog">取消</div>
			</div>
		</div>
<!--		<div class="hotspot-panel-mask" @click="closeDialog"></div>-->
	</div>
</template>

<script>
	import polylineInfo from '../polyline'

	export default {
		props: ['show', 'showDraw'],

		data() {
			return {
				krp: this.$store.getters.krpDom,
				lists: [], //热点集合,
				isShowAddEdit: false,
				editData: null,
				works_id: this.$route.query.id,
				loading: false,
				polylineInfo,
			};
		},

		inject: ['getMid'],

		created() {
			window.krpjs.deletePolyline = this.deletePolyline;
			this.getPolylineList();
		},

		methods: {
			//获取折线
			async getPolylineList() {
				this.loading = true;
				try {
					let res = await this.api.polyline.newLists({
						works_id: this.works_id,
						material_id: this.getMid(),
					});
					this.lists = res.data;
					this.lists.forEach((item) => {
						this.krp.call(`set(hotspot[${item.name}_delete].visible,${item.is_own == 1})`);
					});
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			//新增折线弹窗
			addPolyline() {
				this.isShowAddEdit = true;
			},

			//开始绘制
			startDrawing(e, mode) {
				this.$parent.isShowPolylineDraw = true;
				this.$parent.polylineMode = mode;
				this.$emit('init', e.pageX, e.pageY);
				this.krp.set('control.usercontrol', 'off');
				this.hidePolylineDelete();
				this.$emit('update:show', false);
			},

			hidePolylineDelete() {
				this.lists.forEach((item) => {
					this.krp.call(`set(hotspot[${item.name}_delete].visible,false)`);
				});
			},

			closeDialog() {
				this.hidePolylineDelete();
				this.$emit('update:show', false);
			},

			//删除热点
			async deleteHotSpot(row) {
				try {
					this.$set(row, 'deleteLoading', true);
					await this.api.polyline.delete({id: row.id});
					this.krp.call(`removehotspot(${row.name}))`);
					this.krp.call(`removehotspot(${row.name}_delete))`);
					this.krp.call(`removehotspot(${row.name}_comment))`);
					this.krp.call(`removehotspot(${row.name}_comment_position))`);
					this.$message.success('删除成功');
					this.getPolylineList();
					this.$set(row, 'deleteLoading', false);
				} catch (e) {
					console.error(e);
					this.$set(row, 'deleteLoading', false);
				}
			},

			//定位热点
			positionHotspot(row) {
				let fov = this.krp.get('view.fov');
				this.krp.call(`lookto(${row.comment_ath},${row.comment_atv},${fov},smooth())`);
			},

			//删除-折线-提交
			async deletePolyline(name, id) {
				try {
					await this.$confirm('确认删除?', '提示', {type: 'warning'});
					await this.api.polyline.delete({id});
					this.removePolylineComment(name);
					this.$message.success('删除成功');
					this.getPolylineList();
				} catch (e) {
					console.error(e);
				}
			},

			//删除-折线-按钮-评论
			removePolylineComment(name) {
				this.krp.call(`removehotspot(${name})`);
				this.krp.call(`removehotspot(${name}_delete)`);
				this.krp.call(`removehotspot(${name}_comment)`);
				this.krp.call(`removehotspot(${name}_comment_position)`);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.hotspot-panel {
		width: 350px;
		position: fixed;
		right: 80px;
		top: 20px;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
		z-index: 10;
	}

	.hotspot-panel-mask {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 9;
	}

	.hotspot-list {
		padding: 10px;
		min-height: 200px;
	}

	.hotspot-list .item {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		border: 1px solid #ddd;
		padding: 10px;

		&:hover {
			border-color: #1e9fffcc;
		}
	}

	.hotspot-list .item .icon-box {
		width: 50px;
	}

	.hotspot-list .item .icon {
		display: block;
		height: 30px;
		max-width: 100%;
	}

	.hotspot-list .item .title {
		flex: 1;
		padding: 0 20px 0 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
	}

	.hotspot-list .item .operate {
		font-size: 12px;
	}

	.hotspot-list .item .operate .line {
		margin: 0 3px;
	}

	.hotspot-list .item .operate .btn {
		cursor: pointer;
		user-select: none;
		display: flex;
		align-items: center;

		&:hover {
			font-weight: bold;
		}
	}

	.hotspot-placeholder {
		padding: 100px;
		text-align: center;
	}

	.panel-footer {
		display: flex;
	}

	.panel-footer .btn {
		flex: 1;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		&:hover {
			opacity: 0.8;
		}
	}

	.panel-footer .btn-cancel {
		background: #9e9e9e;
	}

	.hotspot-panel-title {
		padding: 10px 0;
		margin: 0 10px;
		border-bottom: 1px solid #eee;
	}
</style>
